import Vue from 'vue'

import vmodal from 'vue-js-modal'
Vue.use(vmodal, {
  dialog: true,
  dynamic: true
})

import VCalendar from 'v-calendar'
Vue.use(VCalendar)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import DrawerLayout from 'vue-drawer-layout'
Vue.use(DrawerLayout)

import VueLuxon from 'vue-luxon'
Vue.use(VueLuxon, {
  input: {
    zone: 'utc',
    format: 'iso'
  },
  output: 'short'
})

// import FloatingVue from 'floating-vue'
// Vue.use(FloatingVue)
